<template>
	<div :class="['module-list', { 'block-drag': blockDrag }]">
		<SlickList
			v-if="list.length"
			v-model="list"
			:useDragHandle="true"
			lockAxis="y"
			@sort-start="toggleSorting(true)"
			@sort-end="toggleSorting(false)"
		>
			<SlickItem
				v-for="(item, idx) in list"
				:key="idx"
				:index="idx"
				class="module-list__slick-item"
			>
				<div v-handle class="module-list__handle">
					<div class="module-list__handle-left">
						<input
							v-model="copyCheckList"
							:value="item.oIdx"
							type="checkbox"
							class="module-list__copy-input"
						/>
						<span
							class="module-list__slick-label"
							v-text="getLabel(item.id)"
						/>
					</div>
					<button
						class="module-list__slick-delete"
						@click="deleteModule(idx)"
						v-text="'삭제'"
					/>
				</div>
				<CastModule
					ref="moduleElem"
					:data="item"
					:sorting="sorting"
					class="cast-module"
					@input="moduleChange($event, idx)"
				/>
			</SlickItem>
		</SlickList>
		<ManagingSection
			:isTable="true"
			class="module-list__module-type-table-wrapper"
		>
			<table class="table-main module-list__module-type-table">
				<thead>
					<tr>
						<th v-text="'모듈 추가'" />
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="item in moduleTypeList"
						:key="item.id"
						class="module-list__module-type-tr"
					>
						<td class="module-list__module-type-td">
							<button
								class="add-button"
								@click="addModule(item.id)"
							>
								<figure>
									<img
										:src="item.icon"
										class="add-button__img"
									/>
									<figcaption
										class="add-button__label"
										v-text="item.label"
									/>
								</figure>
							</button>
						</td>
					</tr>
					<tr class="module-list__module-type-tr">
						<td
							class="module-list__module-type-td module-list__module-type-td--last"
						>
							<button
								class="btn blue module-list__copy-button"
								v-text="'선택모듈복사'"
								@click="copyModule"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</div>
</template>
<script>
	import { getS3Url, uploadS3 } from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';
	import CastModule from '@/components/cast/CastModule.vue';

	export default {
		name: 'CastModuleList',
		directives: { handle: HandleDirective },
		components: {
			ManagingSection,
			ManagingBox,
			SlickList,
			SlickItem,
			CastModule,
		},
		props: {
			moduleList: {
				type: Array,
				default: null,
			},
		},
		data() {
			return {
				moduleBundle: {
					img: {
						id: 'img',
						type: 'single', // single, tile, 1:1, 4:5, 9:16, 4:1
						imgList: [], // { src: '', link: '' },
						caption: {
							text: '',
							type: '400', // 400, 700
						},
					},
					txt: {
						id: 'txt',
						conts: '',
					},
					youtube: {
						id: 'youtube',
						conts: '',
					},
					pdt: {
						id: 'pdt',
						type: 'list', // list, card, hide
						pdtList: [],
					},
					border: {
						id: 'border',
						type: '1px', // 0, 1px
					},
				},
				list: [],
				sorting: false,
				copyCheckList: [],
				blockDrag: false,
			};
		},
		computed: {
			moduleTypeList() {
				return ['img', 'txt', 'youtube', 'pdt', 'border'].map(id => ({
					id,
					icon: `/static/img/icon/cast-module-${id}.png`,
					label: this.getLabel(id),
				}));
			},
		},
		methods: {
			getLabel(id) {
				return {
					img: '이미지',
					txt: '텍스트',
					youtube: '동영상',
					pdt: '제품',
					border: '구분선',
				}[id];
			},
			deleteModule(idx) {
				this.list.splice(idx, 1);
			},
			getOIdx(oIdx = 0) {
				return this.list.some(item => item.oIdx === oIdx)
					? this.getOIdx(++oIdx)
					: oIdx;
			},
			addModule(id) {
				const oIdx = this.getOIdx();
				this.list.push({ ...this.moduleBundle[id], oIdx });
			},
			moduleChange(data, targetIdx) {
				this.list = this.list.map((item, idx) =>
					targetIdx === idx ? data : item
				);
			},
			async getUploadedImgItem({ src, link, activeIcon }) {
				try {
					if (typeof src === 'object') {
						const { data } = await getS3Url(
							src.extension,
							'cast-module'
						);
						await uploadS3(data, src.fileObject);
						src = `${this.$store.state.env.IMAGE_STORAGE_PATH}/${data.fields.key}`;
					}
					return {
						src,
						link,
						activeIcon,
					};
				} catch (err) {
					console.error(err);
					alert(
						'이미지 모듈의 이미지를 업로드 중 에러가 발생했습니다.'
					);
				}
			},
			async getParsedDataList(data) {
				const parsedData = { ...data };
				if (
					data.id === 'img' &&
					data.imgList.some(({ src }) => typeof src === 'object')
				) {
					parsedData.imgList = await Promise.all(
						data.imgList.map(this.getUploadedImgItem)
					);
				} else if (data.id === 'pdt' && data.pdtList.length) {
					parsedData.pdtList = data.pdtList.map(
						item => item.idProduct
					);
				} else if (data.id === 'txt') {
					parsedData.conts = encodeURIComponent(data.conts);
				}
				return parsedData;
			},
			async getList() {
				return await Promise.all(this.list.map(this.getParsedDataList));
			},
			toggleSorting(bool) {
				this.blockDrag = bool;
				this.sorting = bool;
			},
			copyModule() {
				const checkList = this.copyCheckList;
				if (checkList.length < 1) {
					alert('선택된 모듈이 없습니다.');
					return;
				}
				const selectedList = this.list.filter(item =>
					checkList.some(oIdx => oIdx === item.oIdx)
				);
				selectedList.forEach(item => {
					this.list.push({
						...item,
						oIdx: this.getOIdx(),
					});
				});
				this.copyCheckList = [];
			},
		},
		created() {
			if (this.moduleList) this.list = this.moduleList;
		},
	};
</script>
<style lang="scss" scoped>
	.module-list {
		&__slick-item {
			margin-top: 16px;
		}

		&__handle {
			cursor: grab;
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: center / 32px no-repeat #dfe6ee
				url('/static/img/icon/slick-handle.png');
			padding-right: 32px;
		}

		&__handle-left {
			display: flex;
			align-items: center;
		}

		&__copy-input {
			cursor: pointer;
			display: block;
			width: 28px;
			height: 28px;
			margin-right: 4px;
		}

		&__slick-label {
			color: #677086;
			font-size: 14px;
			font-weight: 700;
		}

		&__slick-delete {
			color: #ff451d;
			font-size: 14px;
			font-weight: 400;
		}

		&__module-type-table-wrapper {
			z-index: 4999;
			position: fixed;
			right: 0;
			bottom: 0;
			width: 80px;
			padding: 0;
		}

		&__module-type-table {
			table-layout: fixed;
		}

		&__module-type-tr:hover {
			background: white;
		}

		&__module-type-td {
			padding: 4px 0;

			&--last {
				padding: 0;
			}
		}

		.add-button {
			&__img {
				display: block;
				width: 34px;
				height: 34px;
			}

			&__label {
				display: block;
				margin-top: 8px;
				line-height: 19px;
				text-align: center;
				font-weight: 700;
			}
		}

		&__copy-button {
			width: 100%;
			height: 100%;
			border-radius: 0;
			padding: 0;
		}
	}

	.block-drag {
		.module-list__slick-item,
		.cast-module {
			user-select: none;
		}
	}
</style>
